import { render, staticRenderFns } from "./VegeIssueInfoDialog.vue?vue&type=template&id=357a5ae1"
import script from "./VegeIssueInfoDialog.vue?vue&type=script&lang=ts"
export * from "./VegeIssueInfoDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports